export async function copyFile(file: File | Blob) {
    const filename = file instanceof File ? file.name : `${file.type}`;
    return new File([await file.arrayBuffer()], filename, { type: file.type });
}

export function handleFunsErrors<T extends { [k: string]: any }>(methods: T): T {
    return Object.keys(methods).reduce((nweMethods, key) => {
        nweMethods[key] = async function (...args: any[]) {
            try {
                return await methods[key](...args);
            } catch (error) {
                return {
                    type: 'error',
                    message: (error as Error).message,
                };
            }
        };
        return nweMethods;
    }, {} as any);
}

export function assert(condition: boolean, message: string) {
    if (!condition) {
        throw new Error(message);
    }
}
